import React, {useEffect, createContext, useContext, useCallback} from 'react';

import OLMap from 'ol/Map';
import {Attribution} from 'ol/control';
import {defaults as defaultInteractions} from 'ol/interaction';

import {useObject} from 'topmeteo/general/hooks';

const Context = createContext(null);

export const useMap = (callback, dependencies) => {
    const handler = useCallback(callback, dependencies);
    const map = useContext(Context);

    useEffect(
        () => {
            if (map) return handler(map);
        },
        [map, handler],
    );

    return null;
};

const Controls = [
    new Attribution(),
];

const Interactions = defaultInteractions({altShiftDragRotate: false, pinchRotate: false});

const Map = ({target, children}) => {
    const map = useObject(() => new OLMap({target, controls: Controls, interactions: Interactions}), [target]);

    return (
        <Context.Provider value={map}>
            {children}
        </Context.Provider>
    );
};

export default Map;
